/**
 * PLACEHOLDER absolute match threshold (§3.3). Drawn from the spike's
 * pessimistic bound (~0.83 recognition floor); the deployed grader knows the
 * target so its false-reject rate should land better. Phase-2's first task is
 * to calibrate this on the maintainer's own hand-traces. One-line tightening
 * IS the calibration interface — do not scatter threshold logic elsewhere.
 */
export const MATCH_THRESHOLD = 0.62

/**
 * Stamped on every draw_capture row (spec §9.1). Bump on ANY
 * grading-affecting change: matcher lib, threshold, samplesPerStroke.
 * Format: <matcher>/<threshold>/<samples>.
 */
export const GRADER_VERSION = 'cm-1.1.1/t0.62/s32'
